import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthRequiredContext = createContext(null);

export const AuthRequiredProvider = ({ children }) => {
  const [showAuthModal, setShowAuthModal] = useState(false);

  const triggerAuthModal = useCallback(() => {
    setShowAuthModal(true);
  }, []);

  const closeAuthModal = useCallback(() => {
    setShowAuthModal(false);
  }, []);

  return (
    <AuthRequiredContext.Provider value={{ showAuthModal, triggerAuthModal, closeAuthModal }}>
      {children}
    </AuthRequiredContext.Provider>
  );
};

export const useAuthRequired = () => {
  const context = useContext(AuthRequiredContext);
  if (!context) {
    throw new Error('useAuthRequired must be used within AuthRequiredProvider');
  }
  return context;
};
